import { JsonPipe, PlatformLocation } from '@angular/common';
import {
  Component,
  computed,
  inject,
  NO_ERRORS_SCHEMA,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { injectDevFlagsObservable } from '@core/tellent-dev-flags-logic';
import { TellentNavigationRoutingService } from '@core/tellent-logic';
import {
  APP_GUID,
  AppKind,
  injectTellentAppKind,
  ORG_GUID,
  TELLENT_CLIENT_CONFIG,
} from '@core/tellent-types';
import { ButtonComponent } from '@core/user-interface-legacy';

import { AppRevisionToken } from '../../app/app.revision';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tlc-playground-default',
  templateUrl: 'playground-default.component.html',
  styleUrl: 'playground-default.component.less',
  encapsulation: ViewEncapsulation.ShadowDom,
  schemas: [NO_ERRORS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JsonPipe, ButtonComponent],
})
export class PlaygroundDefaultComponent {
  #version = inject(AppRevisionToken);
  #appKind = injectTellentAppKind();
  #orgGuid = inject(ORG_GUID);
  #appGuid = inject(APP_GUID);
  #platformLocation = inject(PlatformLocation);
  #config = inject(TELLENT_CLIENT_CONFIG);
  #navService = inject(TellentNavigationRoutingService);
  #devFlags = toSignal(injectDevFlagsObservable());

  public appKinds = Object.entries(AppKind).map(([k, v]) => ({
    active: v === this.#appKind,
    url: `${window.location.origin}${this.#platformLocation.getBaseHrefFromDOM()}${v}/`,
    label: k,
  }));

  public debug = computed(() => ({
    config: this.#config,
    debug: {
      version: this.#version,
      devFlags: Object.entries(this.#devFlags() || {})
        .filter(([_, value]) => value)
        .map(([key]) => key)
        .sort(),
    },
    environment: {
      appKind: this.#appKind,
      orgGuid: this.#orgGuid,
      appGuid: this.#appGuid,
    },
    runtime: {
      domBaseHref: this.#platformLocation.getBaseHrefFromDOM(),
      location: this.#navService.location(),
    },
  }));

  public selectAppKind(url: string) {
    window.open(url, '_self');
  }
}
